@if (spinnerState.loading() || !OPDData) {
} @else {
  <div class="sticky dialog-header flex justify-between">
    <div class="flex items-center">
      <div>
        <p-tag
          [severity]="calOPDStatus(OPDData.status)"
          [value]="'common.options.check_opd.' + OPDData.status | translate"
          class="mr-4"
        />
        <b>{{ title }}</b>
      </div>
    </div>
    <div class="float-right flex gap-5 items-center">
      @if (config.data?.docNo && [Mode.CREATE, Mode.EDIT].includes(mode)) {
        <p-button
          (onClick)="onCancelOPD(config.data?.docNo)"
          [label]="'page.queue.action.cancel_opd' | translate"
          [severity]="'danger'"
          icon="pi pi-ban"
        ></p-button>
      }
      <button (click)="onClose()" class="pi pi-times" style="font-size: 1.25rem"></button>
    </div>

    @if (mode === Mode.VIEW) {
      @if (OPDData.status === OPDStatus.WAITING_FOR_PAYMENT && OPDData.invoiceStatus === InvoiceStatus.OVERDUE) {
        <div class="pt-8 justify-self-end">
          <p-button [label]="'page.expense.button.complete_invoice' | translate" class="btn-primary"></p-button>
        </div>
      }
    }
  </div>

  <div>
    <div class="grid grid-cols-5">
      <div class="grid">
        @if (OPDData.customerFullInformation) {
          <img
            [src]="OPDData.customerFullInformation.photo || 'assets/images/no-image.jpg'"
            alt="photo"
            class="image-personal"
          />
        } @else {
          <img [src]="'assets/images/no-image.jpg'" alt="photo" class="image-personal" />
        }
      </div>
      <div class="grid">
        <div>
          <b>
            {{ OPDData.customerFullInformation.prefix }}{{ OPDData.customerFullInformation.name }}
            {{ OPDData.customerFullInformation.surname }}
          </b>
        </div>
        <div>
          <b>{{ 'page.expense.label.birthday' | translate }} :</b>
          {{ (OPDData.customerFullInformation.birthday | date: 'dd/MM/yyyy') || '-' }}
        </div>
        <div>
          <b>{{ 'page.expense.label.age' | translate }}:</b> {{ calculateAge() }}
        </div>
        <div>
          <b>{{ 'page.expense.label.sex' | translate }}:</b> {{ OPDData.customerFullInformation.sex || '-' }}
        </div>
        <div>
          <b>{{ 'page.expense.label.nickname' | translate }} :</b>
          {{ OPDData.customerFullInformation.nickname || '-' }}
        </div>
        <div>
          <b>{{ 'common.label.note' | translate }}:</b> {{ OPDData.customerFullInformation.note || '-' }}
        </div>
      </div>
      <div class="grid">
        <div class="row-span-2">
          <b
            ><u>{{ 'page.expense.section.information' | translate }}</u></b
          >
        </div>
        <div class="row-span-2">
          <b>{{ 'page.expense.label.weight' | translate }} :</b> {{ OPDData.customerFullInformation.weight || '-' }}
        </div>
        <div class="row-span-2">
          <b>{{ 'page.expense.label.height' | translate }} :</b> {{ OPDData.customerFullInformation.height || '-' }}
        </div>
        <div class="row-span-1">
          <b>{{ 'page.expense.label.blood_type' | translate }} :</b>
          {{ OPDData.customerFullInformation.bloodType || '-' }}
        </div>
      </div>
      <div class="grid col-span-2">
        <div class="row-span-2">
          <u
            ><b>{{ 'page.expense.section.medical_history' | translate }}</b></u
          >
        </div>
        <div>
          <b>{{ 'page.expense.label.drug_allergy' | translate }}: </b>
          <label [ngClass]="{ 'text-danger underline': OPDData.customerFullInformation.drugAllergy }"
            ><b>{{ OPDData.customerFullInformation.drugAllergy || '-' }}</b></label
          >
        </div>
        <div>
          <b>{{ 'page.expense.label.mental_health' | translate }}: </b>
          <label [ngClass]="{ 'text-danger underline': OPDData.customerFullInformation.mentalHealth }"
            ><b>{{ OPDData.customerFullInformation.mentalHealth || '-' }}</b></label
          >
        </div>
        <div>
          <b>{{ 'page.expense.label.congenital_disease' | translate }}: </b>
          <label [ngClass]="{ 'text-danger underline': OPDData.customerFullInformation.congenitalDisease }"
            ><b>{{ OPDData.customerFullInformation.congenitalDisease || '-' }}</b></label
          >
        </div>
        <div>
          <b>{{ 'common.label.note' | translate }}: </b>
          <label [ngClass]="{ 'text-danger underline': OPDData.customerFullInformation.healthNote }"
            ><b>{{ OPDData.customerFullInformation.healthNote || '-' }}</b></label
          >
        </div>
      </div>
    </div>
  </div>

  <div class="my-6">
    @if (mode === Mode.CREATE || mode === Mode.EDIT) {
      <p-button
        (click)="goVitalsSign()"
        [label]="'page.customer.button.vital_signs' | translate"
        icon="pi pi-plus"
      ></p-button>
    }
  </div>

  <p-tabs value="0">
    <p-tablist>
      <p-tab value="0">{{ 'page.expense.tab.diagnose' | translate }}</p-tab>
      @if (
        medicals.length > 0 &&
        [OPDStatus.EXAMINING, OPDStatus.WAITING_FOR_PAYMENT, OPDStatus.COMPLETE].includes(OPDData.status)
      ) {
        <p-tab value="1">{{ 'page.expense.tab.medical_certificate' | translate }}</p-tab>
      }
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <p-table [scrollable]="true" [value]="vitalSigns.controls" class="mt-4" scrollHeight="400px">
          <ng-template #header>
            <tr>
              <th style="width: 20%">{{ 'page.queue.label.doc_no' | translate }}</th>
              <th style="width: 20%">{{ 'common.label.created' | translate }}</th>
              <th>{{ 'page.expense.column.diagnosis' | translate }}</th>
              @if (mode === Mode.CREATE || mode === Mode.EDIT) {
                <th class="center" style="width: 5%">{{ 'common.label.action' | translate }}</th>
              }
            </tr>
          </ng-template>
          <ng-template #body let-i="rowIndex" let-opd>
            <tr>
              <td class="text-info">
                <b (click)="goVitalsSign(opd.get('docNo').value)" class="cursor-pointer">{{
                  opd.get('docNo').value
                }}</b>
              </td>
              <td>{{ opd.get('created').value | date: 'dd/MM/yyyy HH:mm' }}</td>
              <td>
                @if (opd.get('icd').value.length > 0) {
                  @for (icd of opd.get('icd').value; track icd.code) {
                    <tr>
                      <td>{{ icd.code }} - {{ icd.name }}</td>
                    </tr>
                  }
                } @else {
                  -
                }
              </td>
              @if (mode === Mode.CREATE || mode === Mode.EDIT) {
                <td class="center">
                  <p-button
                    (onClick)="action.toggle($event)"
                    icon="pi pi-ellipsis-h"
                    severity="secondary"
                    type="button"
                    variant="outlined"
                  />
                  <p-popover #action>
                    <div
                      (click)="goVitalsSign(opd.get('docNo').value)"
                      class="p-3 cursor-pointer flex gap-4 place-items-center"
                    >
                      <i class="pi pi-eye"></i>{{ 'page.queue.action.view_vital_signs' | translate }}
                    </div>
                    <div
                      (click)="goCancelVitalsSign(opd.get('docNo').value)"
                      class="text-danger p-3 cursor-pointer flex gap-4 place-items-center"
                    >
                      <i class="pi pi-ban"></i>{{ 'page.queue.button.cancel_vital_signs' | translate }}
                    </div>
                  </p-popover>
                </td>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td class="justify-items-center py-4" colspan="5">
                <img alt="empty" class="pt-8" src="assets/images/no-data.png" width="100" />
                <div class="pb-8 pt-8">
                  <b>{{ 'common.label.no_data' | translate }}</b>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabpanel>
      <p-tabpanel value="1">
        <p-table [scrollable]="true" [value]="medicals.controls" class="mt-4" scrollHeight="400px">
          <ng-template #header>
            <tr>
              <th style="width: 20%">{{ 'page.queue.label.doc_no' | translate }}</th>
              <th style="width: 40%">{{ 'page.queue.label.ref_doc_no' | translate }}</th>
              <th style="width: 20%">{{ 'common.label.created' | translate }}</th>
              <th class="center" style="width: 5%">{{ 'common.label.action' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template #body let-i="rowIndex" let-mc>
            <tr>
              <td class="text-amber-500">
                <b (click)="goPrintMC(mc.get('mcDocNo')?.value)" class="cursor-pointer">
                  {{ mc.get('mcDocNo')?.value }}</b
                >
              </td>
              <td class="text-info">
                <b (click)="goVitalsSign(mc.get('docNo')?.value)" class="cursor-pointer">{{
                  mc.get('docNo')?.value
                }}</b>
              </td>
              <td>
                {{ mc.get('mcCreated')?.value | date: 'dd/MM/yyyy HH:mm' }}
              </td>
              <td class="center">
                <p-button
                  (onClick)="action.toggle($event)"
                  icon="pi pi-ellipsis-h"
                  severity="secondary"
                  type="button"
                  variant="outlined"
                />
                <p-popover #action>
                  <div
                    (click)="goPrintMC(mc.get('mcDocNo')?.value)"
                    class="p-3 cursor-pointer flex gap-4 place-items-center text-primary"
                  >
                    <i class="pi pi-print"></i>{{ 'page.queue.action.print_mc' | translate }}
                  </div>
                </p-popover>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>

  <p-tabs class="mt-12" value="0">
    <p-tablist>
      <p-tab value="0">{{ 'page.expense.tab.summary' | translate }}</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <form [formGroup]="form">
          <div formArrayName="programs">
            <p-table [scrollable]="true" [value]="programs.controls" class="mt-4">
              <ng-template #header>
                <tr>
                  <th [style]="{ width: '5%' }">{{ 'page.expense.column.no' | translate }}</th>
                  <th [style]="{ width: '10%' }">{{ 'page.expense.column.id' | translate }}</th>
                  <th [style]="{ width: '30%' }">{{ 'page.expense.column.list' | translate }}</th>
                  <th [style]="{ width: '10%' }">{{ 'page.expense.column.amount' | translate }}</th>
                  <th [style]="{ width: '10%' }">{{ 'page.expense.column.unit' | translate }}</th>
                  <th [style]="{ width: '10%' }">{{ 'page.expense.column.price_unit' | translate }}</th>
                  <th [style]="{ width: '10%' }">{{ 'page.expense.column.discount_unit' | translate }}</th>
                  <th [style]="{ width: '10%' }">{{ 'page.expense.column.total' | translate }}</th>
                  @if (mode === Mode.CREATE || mode === Mode.EDIT) {
                    <th [style]="{ width: '5%' }">{{ 'common.label.action' | translate }}</th>
                  }
                </tr>
              </ng-template>
              <ng-template #body let-program let-rowIndex="rowIndex">
                <tr [formGroupName]="rowIndex">
                  @if (mode === Mode.CREATE || mode === Mode.EDIT) {
                    <td>
                      {{ rowIndex + 1 }}
                    </td>
                    @if (program.get('id').value && program.get('name').value) {
                      <td>
                        {{ program.get('id').value }}
                      </td>
                      <td>
                        {{ program.get('name').value }}
                        @if (program.get('drugAdministration').value) {
                          <div (click)="onUpdateUse(rowIndex)" class="mt-2 text-primary cursor-pointer">
                            <b class="underline">{{ 'page.expense.label.drug_use' | translate }}</b
                            >: {{ program.get('drugAdministration').value }}
                          </div>
                          <div>
                            <small
                              [class.text-green-500]="program.get('stock').value >= 20"
                              [class.text-red-500]="program.get('stock').value < 10"
                              [class.text-yellow-500]="
                                program.get('stock').value < 20 && program.get('stock').value >= 10
                              "
                            >
                              {{ 'page.queue.label.stock_remaining' | translate }}
                              : {{ program.get('stock').value }}</small
                            >
                          </div>
                        }
                      </td>
                    } @else {
                      <td [colSpan]="2">
                        <p-auto-complete
                          (completeMethod)="queryList($event)"
                          (onSelect)="onAddList($event, rowIndex)"
                          [placeholder]="'common.label.search_keyword' | translate"
                          [showClear]="true"
                          [suggestions]="listProgram"
                          appendTo="body"
                          class="p-input-text-width w-full col-span-6"
                          optionLabel="name"
                        />
                      </td>
                    }
                    <td>
                      @if (program.get('unitId').value) {
                        <p-input-number
                          [inputStyle]="{ width: '100%' }"
                          [maxlength]="6"
                          [placeholder]="'page.expense.column.amount' | translate"
                          formControlName="amount"
                        ></p-input-number>
                      }
                    </td>
                    <td>
                      @if (program.get('id').value && program.get('name').value) {
                        <app-select
                          (onChangeSelect)="onSelectUnit($event, rowIndex, program.get('unitList').value)"
                          [optionLabel]="'unitName'"
                          [optionValue]="'unitId'"
                          [placeholder]="'common.label.please_select' | translate"
                          [selectedOption]="program.get('unitList')?.value"
                          [showClear]="false"
                          formControlName="unitId"
                        >
                        </app-select>
                      }
                    </td>
                    <td>
                      @if (program.get('unitId').value) {
                        <p-input-number
                          [inputStyle]="{ width: '80px' }"
                          [maxlength]="6"
                          [placeholder]="'page.expense.column.price' | translate"
                          formControlName="price"
                        ></p-input-number>
                      }
                    </td>
                    <td>
                      @if (program.get('unitId').value) {
                        <p-input-number
                          [inputStyle]="{ width: '100%' }"
                          [max]="program.get('price').value"
                          [maxlength]="6"
                          [placeholder]="'page.expense.column.discount' | translate"
                          formControlName="discount"
                        ></p-input-number>
                      }
                    </td>
                    <td>{{ program.get('total').value | number }}</td>
                    <td>
                      @if (program.get('id').value && program.get('name').value) {
                        <p-button
                          (click)="onDeleteProgram(rowIndex)"
                          [icon]="'pi pi-trash'"
                          [rounded]="true"
                          [text]="true"
                          severity="danger"
                        ></p-button>
                      }
                    </td>
                  } @else {
                    <td>{{ rowIndex + 1 }}</td>
                    <td>{{ program.get('id').value }}</td>
                    <td>
                      {{ program.get('name').value }}
                      @if (program.get('drugAdministration').value) {
                        <div (click)="onUpdateUse(rowIndex, Mode.VIEW)" class="mt-2 text-primary cursor-pointer">
                          <b class="underline">{{ 'page.expense.label.drug_use' | translate }}</b
                          >: {{ program.get('drugAdministration').value }}
                        </div>
                      }
                    </td>
                    <td>{{ program.get('amount').value | number }}</td>
                    <td>{{ program.get('unitName').value | translate }}</td>
                    <td>{{ program.get('price').value | number }}</td>
                    <td>{{ (program.get('discount').value | number) || '-' }}</td>
                    <td>{{ program.get('total').value | number }}</td>
                  }
                </tr>
              </ng-template>
            </p-table>

            <div class="w-1/4 float-end pt-8 px-4">
              <div class="flex flex-col">
                <div class="flex mb-2 justify-between">
                  <div>
                    <u>{{ 'page.expense.label.all' | translate }}:</u>
                  </div>
                  <div>{{ form.value.summary | number }}</div>
                </div>

                <p-divider></p-divider>
                <div class="flex mb-2 justify-between">
                  <div>
                    <u>{{ 'page.expense.label.discount_summary' | translate }}:</u>
                  </div>
                  <div>{{ form.value.discount | number }}</div>
                </div>

                <p-divider></p-divider>
                <div class="flex mb-2 justify-between bg-primary text-white p-6 rounded-lg text-xl font-bold">
                  <div>
                    <u>{{ 'page.expense.label.total' | translate }}:</u>
                  </div>
                  <div>{{ form.value.total | number }}</div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>

  <div class="sticky dialog-footer">
    @if (mode === Mode.CREATE || mode === Mode.EDIT) {
      <div class="flex justify-end gap-2">
        <p-button
          (click)="onSave()"
          [disabled]="isSaving"
          [label]="'common.button.save' | translate"
          [loading]="isSaving"
          appPreventDoubleClick
          class="btn-primary"
        ></p-button>
        <p-button (click)="onClose()" [label]="'common.button.cancel' | translate" severity="secondary"></p-button>
      </div>
    }
  </div>
}
